module.exports = __webpack_public_path__ + "img/1.19ec831b.png";